import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'sb-booking-overview-reporting',
  templateUrl: './booking-overview-reporting.component.html',
  styleUrls: ['./booking-overview-reporting.component.scss'],
  standalone: false,
})
export class BookingOverviewReportingComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
